import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@src/design-system/breadcrumb';
import { cn } from '@src/design-system/helpers';
import { Fragment } from 'react';

export function PageTitle({ titles }: { titles: string[] }) {
  return (
    <Breadcrumb>
      <BreadcrumbList
        key={titles.join('-')}
        className='gap-0.5 sm:gap-0.5'
      >
        {titles.map((title, index) => {
          const isLast = index === titles.length - 1;

          return (
            <Fragment key={index}>
              <BreadcrumbItem
                className={cn(
                  'text-gray-500 text-2xl font-semibold !px-0',
                  isLast && 'text-gray-1000'
                )}
              >
                {title}
              </BreadcrumbItem>

              {!isLast && <BreadcrumbSeparator className='[&>svg]:size-6' />}
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
